/**
 * Returns the backend URL configured for the application. If an explicit
 * environment variable is not provided we fall back to the current origin (if
 * available) so unconfigured environments keep talking to the host serving the
 * frontend. This mirrors the historical behaviour where requests used
 * relative paths when no override was supplied.
 */
export const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim().replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.__APP_CONFIG__?.apiBaseUrl) {
    const runtimeUrl = window.__APP_CONFIG__.apiBaseUrl;
    if (runtimeUrl && runtimeUrl.trim()) {
      return runtimeUrl.trim().replace(/\/+$/, '');
    }
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }

  return '';
};

/**
 * Builds an absolute URL by combining the backend URL with the provided path.
 */
export const buildApiUrl = (path = '') => {
  const baseUrl = getBackendUrl();
  if (!path) {
    return baseUrl;
  }

  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
};

export default getBackendUrl;
